module.exports = __webpack_public_path__ + "img/lg_bg.b5b43d40.jpg";